var map = {
	"./symbol_0.png": 42739,
	"./symbol_1.png": 91978,
	"./symbol_2.png": 40961,
	"./symbol_3.png": 68248,
	"./symbol_4.png": 47863,
	"./symbol_5.png": 57870,
	"./symbol_6.png": 76645,
	"./symbol_7.png": 42780,
	"./symbol_8.png": 39435,
	"./symbol_9.png": 75778
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 10422;